<template>
  <!-- 计算器 -->
  <div class="uni-caculate-wrapper">
    <div id="op-history-container" class="hide"></div>
    <div class="inputs-wrapper">
      <input type="text" id="input-top" />
      <input type="text" id="input-bottom" placeholder="0" />
    </div>
    <div class="gradient-divider"></div>
    <div class="row">
      <div data-set="7" class="num">7</div>
      <div data-set="8" class="num">8</div>
      <div data-set="9" class="num">9</div>
      <div data-set="/" class="op">÷</div>
    </div>
    <div class="row">
      <div data-set="4" class="num">4</div>
      <div data-set="5" class="num">5</div>
      <div data-set="6" class="num">6</div>
      <div data-set="*" class="op">x</div>
    </div>
    <div class="row">
      <div data-set="1" class="num">1</div>
      <div data-set="2" class="num">2</div>
      <div data-set="3" class="num">3</div>
      <div data-set="-" class="op">-</div>
    </div>
    <div class="row">
      <div class="num" id="reset">C</div>
      <div data-set="0" class="num">0</div>
      <div data-set="." class="num">.</div>
      <div data-set="+" class="op">+</div>
    </div>
    <div id="equal" data-set="=">=</div>
  </div>
</template>


<script>
import "@/assets/caculate/gsap.min.js";
import caculate from "@/assets/caculate/script.js";
export default {
  name: "ComponentCaculate",
  data() {
    return {};
  },
  mounted() {
    caculate();
  },
  methods: {},
};
</script>

<style lang="scss">
.uni-caculate-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 5px;
  width: 320px;
  position: relative;
  box-shadow: 0 0 60px rgba(143, 205, 255, 0.5);

  .op-item {
    color: white;
    padding: 6px 0;
  }
  input {
    border: 0;
    padding: 12px 36px;
    width: 100%;
    text-align: right;
    letter-spacing: 3px;
    font-weight: 300;
    pointer-events: none;
  }
  .gradient-divider {
    width: 100%;
    border: 0;
    border-top: 2px solid #e6f5ff;
    background: linear-gradient(#e6f5ff, rgba(0, 0, 0, 0));
    padding: 12px 0;
  }
  #input-top {
    font-size: 18px;
    color: #cad0d4;
    border-radius: 5px;
    padding-top: 18px;
    padding-bottom: 0;
    letter-spacing: 5px;
  }
  #input-bottom {
    font-size: 60px;
    color: #929ea7;
    height: 106px;
    letter-spacing: 5px;
  }
  .row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 12px 9px;
  }
  .num {
    cursor: pointer;
    font-weight: 600;
    color: #74828f;
    padding: 24px;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ::placeholder {
    color: #74828f;
    opacity: 0.3;
  }
  .op {
    border-radius: 50%;
    box-shadow: 0 9px 12px #e3f3ff;
    padding: 24px;
    width: 6px;
    height: 6px;
    @include fontColor("primary");
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #reset {
    color: #ff8787;
  }
  #equal {
    @include bgColor("primary");
    color: white;
    font-size: 24px;
    width: 70%;
    text-align: center;
    border-radius: 3px;
    padding: 9px 0;
    position: relative;
    top: 21px;
    box-shadow: 0 0 18px rgba(88, 179, 255, 0.5);
  }
  .hide {
    opacity: 0;
    pointer-events: none;
    transition: all 300ms ease-out;
  }
  .disclaimer {
    margin-top: 4em;
    @include fontColor("primary");
    opacity: 0.5 !important;
  }
  .disclaimer a {
    color: #58b3ff;
    text-decoration: none;
  }
  .disclaimer span:hover {
    cursor: pointer;
  }
  @media (max-height: 720px) {
    .main-wrapper {
      transform: scale(0.8);
    }
    .disclaimer {
      margin-top: 0;
    }
  }
}
</style>
